import getClient from "./getClient";

const getDisplayName = (user) => {
  let name = user?.email;
  let userMetadata = user?.user_metadata;

  if (userMetadata?.firstName) {
    name = userMetadata.firstName;

    if (userMetadata?.lastName) {
      name += ` ${user?.user_metadata?.lastName}`;
    }
  }

  return name;
};

export default function getUser() {
  return getClient()
    .auth.getUser()
    .then((result) => {
      if (result.error) return result;
      const user = result.data.user;

      return {
        user: {
          ...user,
          user_metadata: {
            ...user.user_metadata,
            displayName: getDisplayName(user),
          },
        },
      };
    });
}
